<template>
  <section class="py-32 text-center">
    <div class="max-w-3xl mx-auto px-6 reveal">
      <h2 class="text-4xl font-bold mb-6">準備好升級您的網店了嗎？</h2>
      <p class="text-gray-500 mb-10 text-lg">
        快樂買購物系統，提供最純粹的銷售體驗。<br />現在就聯繫我們，開啟您的高轉換之旅。
      </p>
      <div class="flex flex-col sm:flex-row justify-center gap-4">
        <button
          class="px-10 py-4 bg-brand text-white rounded-full font-bold text-lg hover:bg-rose-700 shadow-xl shadow-rose-200 transition-all"
        >
          免費試用方案
        </button>
        <button
          class="px-10 py-4 bg-white border border-gray-200 text-gray-700 rounded-full font-bold text-lg hover:bg-gray-50 transition-colors"
        >
          聯絡專人業務
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CTASection",
};
</script>
